import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {ChromoLogoColor, StockLogoFromBackend} from "../selectableObjects";
import {StocklogoViewController} from "./stocklogoViewController";
import type {StockLogoColorVersion} from "../pattern/patternFarbVorschlaege";
import globalsObject from "../globalsObject";
import {LogoTargetAfterChoosing, RahmentabsLogoReiter} from "../rahmentabsModules/rahmenTabsLogoReiter";
import {SelObTypes} from "../SelObTypes";


export type StockLogoPoolEntry = {
    stockLogoID: number;
    Name: string;
    nameLocalized;
    colors: ChromoLogoColor[];
    previewPicture;
    keywords:string[];
    keywordsJoinedLowerCase:string
    IsPattern;
    standardSizeCM;
    maxSizeCM;
    minSizeCM;
    colorVersions: StockLogoColorVersion[];
    discarded:boolean
}

export class StocklogoEventnames {
    public static DISPLAYCATEGORY = "displayCategoryEvent";
    public static LOGOCLICKED = "logoClickedEvent";
    static LOGOSLOADED = "logDBLogosLoadedEvent";
}

export type StockLogoCategory = {
    name,
    nameLocalized,
    isPatternKategorie,
    logos:any[]|undefined,
    previewStockLogoID,
    enthaeltLogosMitWeisserRandflaeche,
    enthaeltUnterkategorien,
    masterkategorie: string|null,
    logonamenAnzeigen:boolean
}

export interface StockLogoStore {
    getStockLogoAndPatternCategories():StockLogoCategory[];
    getStockLogoCategory(categoryName: string): StockLogoCategory | null;
    getCategoryForStockLogoID(stockLogoID): StockLogoCategory | null;
    getStockLogo(id): StockLogoPoolEntry | null;
    getStockLogoSubCategories(categoryName: string): StockLogoCategory[];
    setStockLogoCategories(stocklogos: StockLogoCategory[]): void;
    loadLogos(language):void;
    getStockLogoCategories():StockLogoCategory[];
    getPatternCategories():StockLogoCategory[];
    getOriginalSVG(stockLogoID):Promise<StockLogoFromBackend>,
    getLocalizedName(stocklogoID):string
    getVorschauSVG(stockLogoID):Promise<string>
}

export class StocklogoController extends EventListener{

    private static stockLogoCategoriesContainer:StockLogoStore;
    private static isAllowed: () => boolean;
    private static languageIso;

    public constructor(stockLogoStore:StockLogoStore, isAllowed: () => boolean, languageIso) {
        super();
        StocklogoController.stockLogoCategoriesContainer = stockLogoStore;
        StocklogoController.isAllowed = isAllowed;
        StocklogoController.languageIso = languageIso;
        this.addEventListener(StocklogoEventnames.LOGOCLICKED, (id) => StocklogoController.logoClicked(id));
        StocklogoController.loadLogos();
    }

    private static logoClicked(id) {
        const logo = StocklogoController.getLogo(id);
        if (logo === null) {
            return;
        }
        StocklogoController.addLogoToLibrary(logo);

    }

    public static getLogos = () => StocklogoController.stockLogoCategoriesContainer.getStockLogoCategories();
    public static getPatterns = () => StocklogoController.stockLogoCategoriesContainer.getPatternCategories();

    public static getCategoryForStockLogoID(stockLogoID) {
        return StocklogoController.stockLogoCategoriesContainer.getCategoryForStockLogoID(stockLogoID);
    }

    private static addLogoToLibrary(logo: StockLogoPoolEntry) {
        EventVerteiler.broadcastBlockRequest("addStockLogoToLibrary");
        $.get("/konfigurator_php/stocklogos/addToLibrary.php?id=" + logo.stockLogoID, function (result) {
            if (result === "success") {
                StocklogoController.logoAddedToLibrary();
            }
            EventVerteiler.broadcastBlockRequestEnded("addStockLogoToLibrary");
            if(RahmentabsLogoReiter.logoTargetAfterChoosing === LogoTargetAfterChoosing.DRAFT) {
                globalsObject.resourceManager.createTask("insertLogo"+logo.stockLogoID).discardAfterExecution().when("logoPool", "loaded").thenDo(
                    ()=>EventVerteiler.broadcast("directlyCreateLogoEvent", {type:SelObTypes.STOCKLOGO, id: logo.stockLogoID})
                )
            }
        })
    }

    private static logoAddedToLibrary() {
        EventVerteiler.broadcast("logoPoolChangedEvent");
        StocklogoViewController.hideAllOverlays();
        StocklogoViewController.hideOverlay("logopool");
        StocklogoViewController.hideOverlay("logopool");
    }

    public static getLogo(id): StockLogoPoolEntry | null {
        return StocklogoController.stockLogoCategoriesContainer.getStockLogo(id);
    }

    private static loadLogos() {
        StocklogoController.stockLogoCategoriesContainer.loadLogos(StocklogoController.languageIso);
    }

    public static getCategory(categoryName: string): StockLogoCategory | null {
        return StocklogoController.stockLogoCategoriesContainer.getStockLogoCategory(categoryName);
    }

    public static getSubCategories(categoryName: string) {
        return StocklogoController.stockLogoCategoriesContainer.getStockLogoSubCategories(categoryName);

    }

    public static patternsFreigeschaltetFuerProdukt() {
        return StocklogoController.isAllowed();
    }

    public static stockLogoHasColorTips(stockLogoID: number) {
        return (this.getLogo(stockLogoID) as StockLogoPoolEntry).colorVersions.length > 0
    }

    public static getColorVersions(stockLogoID: number) {
        return (this.getLogo(stockLogoID) as StockLogoPoolEntry).colorVersions;
    }
}
